import {Protocol} from 'pmtiles';
import * as maplibregl from 'maplibre-gl';
import layers from 'protomaps-themes-base';

let map = null;
export let geolocateControl = null;

export function initMap() {
  let protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);

  map = initMapInstance();

  // Lock the map to north
  map.dragRotate.disable();
  map.keyboard.disable();
  map.touchZoomRotate.disableRotation();

  map.once('load', () => {
    // initSourceHydrantsHamburg(map);
    // initLayerHydrantsHamburg(map);

    // initSourceHydrantsHamburgOSM(map);
    // initLayerHydrantsHamburgOSM(map);

    initSourceHydrantsHamburgOSMGeoJSON(map);
    initLayerHydrantsHamburgOSMGeoJSON(map);

    initSourceHydrantsHamburgGeoJSON(map);
    initLayerHydrantsHamburgGeoJSON(map);

    initGeoLocateControl();
  });
}

function initMapInstance() {
  let protocol = new Protocol();
  maplibregl.addProtocol('pmtiles', protocol.tile);

  return new maplibregl.Map({
    container: 'map',
    style: {
      version: 8,
      glyphs: 'https://cdn.protomaps.com/fonts/pbf/{fontstack}/{range}.pbf',
      sources: {
        protomaps: {
          type: 'vector',
          url: `pmtiles://${location.origin}/tiles/hamburg.pmtiles`,
          attribution:
            '<a href="https://protomaps.com">Protomaps</a> © <a href="https://openstreetmap.org">OpenStreetMap</a>'
        }
      },
      layers: layers('protomaps', 'white', 'de')
    },
    center: [10, 53.555],
    zoom: 12
  });
}

function initSourceHydrantsHamburg(map) {
  map.addSource('hydrants_hamburg', {
    type: 'vector',
    url: `pmtiles://${location.origin}/tiles/hydrants_hamburg.pmtiles`
  });
}

function initSourceHydrantsHamburgOSM(map) {
  map.addSource('hydrants_osm_hamburg', {
    type: 'vector',
    url: `pmtiles://${location.origin}/tiles/hydrants_osm_hamburg.pmtiles`
  });
}

function initSourceHydrantsHamburgGeoJSON(map) {
  map.addSource('hydrants_hamburg_geojson', {
    type: 'geojson',
    data: `${location.origin}/tiles/hydrants_hamburg.geojson`
  });
}

function initSourceHydrantsHamburgOSMGeoJSON(map) {
  map.addSource('hydrants_osm_hamburg_geojson', {
    type: 'geojson',
    data: `${location.origin}/tiles/hydrants_osm_hamburg.geojson`
  });
}

function initLayerHydrantsHamburg(map) {
  map.addLayer({
    id: 'hydrants_hamburg_layer',
    type: 'circle',
    source: 'hydrants_hamburg',
    'source-layer': 'hydrants_hamburg',
    paint: {
      'circle-radius': 5,
      'circle-color': '#8b2016'
    }
  });
}

function initLayerHydrantsHamburgOSM(map) {
  map.addLayer({
    id: 'hydrants_osm_hamburg_layer',
    type: 'circle',
    source: 'hydrants_osm_hamburg',
    'source-layer': 'hydrants_osm_hamburg',
    paint: {
      'circle-radius': 5,
      'circle-color': '#8b2016'
    }
  });
}

function initLayerHydrantsHamburgGeoJSON(map) {
  map.addLayer({
    id: 'hydrants_hamburg',
    type: 'circle',
    source: 'hydrants_hamburg_geojson',
    minzoom: 13,
    paint: {
      'circle-radius': 5,
      'circle-color': '#8b2016'
    }
  });
}

function initLayerHydrantsHamburgOSMGeoJSON(map) {
  map.addLayer({
    id: 'hydrants_osm_hamburg',
    type: 'circle',
    source: 'hydrants_osm_hamburg_geojson',
    minzoom: 13,
    paint: {
      'circle-radius': 4,
      'circle-color': '#d0a5a1'
    }
  });
}

function initGeoLocateControl() {
  geolocateControl = new maplibregl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true
    },
    trackUserLocation: true
  });

  map.addControl(geolocateControl);

  geolocateControl.on('trackuserlocationend', () => {
    // Might activate searchbox again
    console.log('A trackuserlocationend event has occurred.');
  });
}

let addressPin = null;

export function setAddressPin(lat: number, lng: number) {
  if (addressPin) {
    clearAddressPin();
  }

  const pin = document.createElement('div');
  pin.innerHTML = '🏠';
  pin.style.fontSize = '30px';

  addressPin = new maplibregl.Marker({element: pin, anchor: 'bottom'})
    .setLngLat([lng, lat])
    .addTo(map);

  addressPin.on('click', () => {
    map.flyTo({center: {lat, lng}, zoom: 16});
  });
}

export function clearAddressPin() {
  addressPin?.remove();
  addressPin = null;
}

export function setMapLocation(lat: number, lng: number) {
  map.flyTo({center: {lat, lng}, zoom: 16});
}
